import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import BoltIcon from "@mui/icons-material/Bolt";
import LocalFireDepartmentIcon from "@mui/icons-material/LocalFireDepartment";
import WaterDropIcon from "@mui/icons-material/WaterDrop";
import GasMeterIcon from "@mui/icons-material/GasMeter";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import React, { useContext, useMemo } from "react";
import { useTextDomainContext } from "@/app/providers";

interface MenuItemLocationProps<TRow extends object = Record<string, unknown>> {
  row?: TRow;
  menuFor?: string;
  handleClose: () => void;
  menuClick: (_action: string, _row?: TRow) => void;
  showItems?: Record<string, boolean | undefined>;
}

const show: boolean = false;

export const MenuItemLocation = <TRow extends object = Record<string, unknown>>(
  props: MenuItemLocationProps<TRow>,
): React.ReactElement => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);

  const menuFor = useMemo(() => {
    return props.menuFor ?? "";
  }, [props.menuFor]);

  const handleClose = () => {
    props.handleClose();
  };

  const handleElectricityAction = () => {
    props.menuClick(`${menuFor}-electricity`, props.row);
    handleClose();
  };

  const handleHeatingAction = () => {
    props.menuClick(`${menuFor}-heating`, props.row);
    handleClose();
  };

  const handleWaterAction = () => {
    props.menuClick(`${menuFor}-water`, props.row);
    handleClose();
  };

  const handleGasAction = () => {
    props.menuClick(`${menuFor}-gas`, props.row);
    handleClose();
  };

  const handleEnergyAction = () => {
    props.menuClick(`${menuFor}-energy`, props.row);
    handleClose();
  };

  return (
    <>
      <MenuItem onClick={handleElectricityAction}>
        <ListItemIcon>
          <BoltIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText primary={gettext("Electricity Meters")} />
      </MenuItem>

      {show && (
        <MenuItem onClick={handleHeatingAction}>
          <ListItemIcon>
            <LocalFireDepartmentIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary={gettext("Heating Meters")} />
        </MenuItem>
      )}

      {show && (
        <MenuItem onClick={handleWaterAction}>
          <ListItemIcon>
            <WaterDropIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary={gettext("Water Meters")} />
        </MenuItem>
      )}
      <MenuItem onClick={handleGasAction}>
        <ListItemIcon>
          <GasMeterIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText primary={gettext("Natural Gas Meters")} />
      </MenuItem>

      {show && (
        <MenuItem onClick={handleEnergyAction}>
          <ListItemIcon>
            <AutorenewIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary={gettext("Energy Meters")} />
        </MenuItem>
      )}
    </>
  );
};
